module.exports = __webpack_public_path__ + "static/media/arrow-inex.112f69c7.svg";